import React, { useState, useRef } from 'react'
import { NavLink } from 'react-router-dom'

function Loginscreen() {
  const [showFirstIcon, setShowFirstIcon] = useState(true)
  const [isLoginSection, setIsLoginSection] = useState(true)
  const [values, setValues] = useState(Array(6).fill(''))

  // Use a single useRef for the array
  const inputRefs = useRef(Array.from({ length: 6 }, () => React.createRef()))

  const toggleIcon = () => {
    setShowFirstIcon(prev => !prev)
  }
  const toggleSection = () => {
    setIsLoginSection(!isLoginSection)
  }

  const handleKeyUp = (index, event) => {
    const value = event.target.value
    const key = event.key

    // Make a copy of the current values array
    const newValues = [...values]

    if (key === 'Backspace' || key === 'Delete') {
      // Clear current input and move to previous
      newValues[index] = ''
      setValues(newValues)

      if (index > 0) {
        inputRefs[index - 1].current.focus()
      }
    } else {
      // Check if input is a single digit
      const code = parseInt(value)
      if (code >= 0 && code <= 9) {
        newValues[index] = code.toString()
        setValues(newValues)

        // Move to next input if available
        if (index < inputRefs.length - 1) {
          inputRefs[index + 1].current.focus()
        }
      } else {
        // Clear invalid input
        newValues[index] = ''
        setValues(newValues)
      }
    }
  }

  return (
    <>
      <div
        className="d-flex justify-content-between flex-column py-5"
        style={{ minHeight: '100vh' }}
      >
        <div className="d-flex justify-content-center mb-5">
          <div className="fw-bold fs-2">YECC Support</div>
        </div>
        <div
          className="d-flex justify-content-center flex-column"
          style={{ minHeight: '80vh' }}
        >
          <div className="mx-auto px-4 w-100" style={{ maxWidth: '18rem' }}>
            <div>
              <form>
                {isLoginSection ? (
                  <section>
                    <div className="fileds d-flex flex-column gap-3">
                      <input type="text" placeholder="Email or Username" />
                      <div style={{ position: 'relative' }}>
                        <input type="password" placeholder="Password" />
                        <label className="hideandshow" onClick={toggleIcon}>
                          {showFirstIcon ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              aria-hidden="true"
                              className="w-4"
                              style={{ width: '1rem' }}
                            >
                              <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"></path>
                              <path
                                fillRule="evenodd"
                                d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              aria-hidden="true"
                              className="w-4"
                              style={{ width: '1rem' }}
                            >
                              <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"></path>
                              <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"></path>
                              <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"></path>
                            </svg>
                          )}
                        </label>
                      </div>

                      <button
                        className="pulls-right"
                        type="button"
                        onClick={toggleSection}
                      >
                        Log In
                      </button>

                      <div className="pw-reset">
                        <a className="hidden">Forgot My Password</a>
                      </div>
                    </div>
                  </section>
                ) : (
                  <section>
                    <div className="title">OTP</div>
                    <div className="title">Verification Code</div>
                    <p>
                      We have sent a verification code to your mobile number
                    </p>
                    <div id="inputs" className="d-flex">
                      {[...Array(6)].map((_, index) => (
                        <input
                          key={index}
                          ref={inputRefs[index]}
                          className="varify"
                          type="text"
                          maxLength="1"
                          value={values[index]}
                          onChange={e => {
                            const newValues = [...values]
                            newValues[index] = e.target.value
                            setValues(newValues)
                          }}
                          onKeyUp={e => handleKeyUp(index, e)}
                        />
                      ))}
                    </div>
                    <NavLink to="/dashboard">
                      <button className="pulls-right mt-2">Submit</button>
                    </NavLink>
                  </section>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Loginscreen
